import CrudCustom from '../../../libs/custom/CrudCustom';

let TipeHubunganIstimewa = new CrudCustom('/tipe-hubungan-istimewas');
export default TipeHubunganIstimewa;
